import { ITheme } from '@caslink/common-client';

const lightTheme: ITheme = {
    name: 'casLight',
    label: 'light',
    isDark: false
};

const darkTheme: ITheme = {
    name: 'casDark',
    label: 'dark',
    isDark: true
};

export const defaultThemes = {
    light: lightTheme,
    dark: darkTheme
};
